import React from 'react'

class ScopeAppComponent extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

  render () {
    const {app} = this.props
    const {open} = this.state
    const items = []
    const dropdownScope = []
    const classDropdown = open ? 'dropdown open' : 'dropdown'
    for (const [index, value] of app.scopes.entries()) {
      if (index > 1 && app.scopes.length > 3) {
        dropdownScope.push(<li><a>{this._capitalize(value)}</a></li>)
      } else {
        items.push(<div className={'col-sm-4'}>
          <div className={`btn btn-default disabled btn-scope`}>{this._capitalize(value)}</div>
        </div>)
      }
    }
    if (dropdownScope.length > 0) {
      items.push(
        <div className={' col-sm-4'}>
          <div className={classDropdown}>
            <div className='btn btn-default dropdown-toggle btn-scope' type='button' onClick={this._toogle}>
              Others{' ' + dropdownScope.length + '+'} <img
                src={'https://i.gojekapi.com/darkroom/moka/v2/images/static/open-platform/api-ext-assets/static/scope_arrow_dd.svg'}
                className={'dd-arrow'} />
            </div>
            <ul role='menu' className='dropdown-menu dropdown-menu-right dropdown-scope'
              aria-labelledby='dropdown-scopes'>
              {dropdownScope}
            </ul>
          </div>
        </div>
      )
    }

    return <div className={'row'}>
      {items}
    </div>
  }

  _capitalize (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  _toogle = () => {
    const {open} = this.state
    this.setState({open: !open})
  }
}

export default ScopeAppComponent



// WEBPACK FOOTER //
// app/javascript/components/frags/ScopeList/content.js